import React from 'react';

const Footer = () => (
  <footer className="app-footer bg-light py-2 mt-auto border-top">
    <div className="container text-center">
      <small>© {new Date().getFullYear()} LiveClass Pro – React, PHP, MySQL & WebRTC</small>
    </div>
  </footer>
);

export default Footer;
